import {
  Button,
  Heading,
  Link,
  LoadingSpinner,
  Text,
  YStack,
} from "@/components";

type PendingContentProps = {
  message?: { title: string; subtitle?: string };
  ctaLabel?: string;
  onCtaPress?: () => void;
  showSupportLink?: boolean;
};

const PendingContent = ({
  message,
  ctaLabel,
  onCtaPress,
  showSupportLink,
}: PendingContentProps) => (
  <>
    <YStack
      flex={1}
      justifyContent="center"
      alignItems="center"
      padding="$400"
      gap="$200"
    >
      {!message ? (
        <>
          <LoadingSpinner size={72} />
          <YStack>
            <Text textAlign="center" bold>
              Please stand by
            </Text>
            <Text textAlign="center" color="$textSecondary">
              It'll only take a moment...
            </Text>
          </YStack>
        </>
      ) : (
        <YStack gap="$250" alignItems="center" width="100%">
          <YStack gap="$100" alignItems="center">
            <Heading size="$md" textAlign="center">
              {message.title}
            </Heading>
            {message.subtitle && (
              <Text size="$sm" color="$textSecondary" textAlign="center">
                {message.subtitle}
              </Text>
            )}
          </YStack>
        </YStack>
      )}
    </YStack>

    {ctaLabel && onCtaPress && (
      <YStack padding="$200">
        <Button mode="primary" onPress={onCtaPress} width="100%">
          {ctaLabel}
        </Button>
      </YStack>
    )}

    {showSupportLink && (
      <YStack
        paddingHorizontal="$200"
        paddingBottom="$200"
        justifyContent="center"
        alignItems="center"
      >
        <Text size="$sm" color="$textSecondary">
          Having trouble?{" "}
          <Link
            size="$sm"
            bold
            href="https://www.curaihealth.com/support"
            external
          >
            Contact support
          </Link>
        </Text>
      </YStack>
    )}
  </>
);

export default PendingContent;
